import { API_APPLIANCE_VERSION } from './redux/api/endpoints';
import { ACTION_TYPE } from './redux/actionType';
import { makeApiAction, RsaaTypes, ApiReducer, makeApiReducer } from './redux/api/reduxStandardApiAction';
import { IAppState } from './redux/IAppState';
import { getLoading, addLoading, addError, removeLoadingAndError } from './redux/api/module';
import { hasTrippedBreaker, updateBreaker } from './redux/api/circuitBreaker/module';
import { assoc } from '../language/module';
import { getResource } from '../language/resources/getResource';


export const KEY_ACTION = ACTION_TYPE.APPLIANCE_VERSION_REQUEST;
export const ACTIONS    = [
  ACTION_TYPE.APPLIANCE_VERSION_REQUEST,
  ACTION_TYPE.APPLIANCE_VERSION_RESPONSE,
  ACTION_TYPE.APPLIANCE_VERSION_ERROR,
];


/**
 * An action that can be dispatched to retrieve the appliance version of the API. Currently retrieves a .json file
 * stored locally
 */
export const getApplianceVersionAction = () => makeApiAction(
  {
    method:   'GET',
    endpoint: API_APPLIANCE_VERSION,
    types:    ACTIONS as RsaaTypes,
    bailout:  (state: IAppState) => !!getLoading(state, KEY_ACTION, KEY_ACTION) || hasTrippedBreaker(state, KEY_ACTION),
  },
);


const reducer: ApiReducer<string> = (state, action, error, isLoading, payload) => {
  if (isLoading) {
    return addLoading(state, KEY_ACTION, KEY_ACTION);
  }

  const withBreaker = updateBreaker(state, KEY_ACTION, !!error);

  if (error) {
    return addError(
      withBreaker,
      KEY_ACTION,
      KEY_ACTION,
      error || getResource(state.locale, 'GET_APPLIANCE_VERSION_ACTION_ERROR'),
    );
  }

  const noLoadingOrError = removeLoadingAndError(withBreaker, KEY_ACTION, KEY_ACTION);

  return assoc('applianceVersion', (payload as any).version, noLoadingOrError);
};


/**
 * Maps getApplianceVersionActions onto old app state to make a new state.
 */
export const getApplianceVersionReducer = makeApiReducer<string>(ACTIONS, KEY_ACTION, reducer);
